import { useCallback, useEffect, useState } from 'react';
import {
  IExpectedHoursItem,
  type IExpectedHoursListFilters,
} from '../services/types/expectedHours';
import {
  acceptSettlement as acceptSettlementRequest,
  buildWorkItemsApiFilters,
  getExpectedHoursForMonth,
  rejectSettlement as rejectSettlementRequest,
} from '../services/expectedHoursService';
import { monthNames } from '../utils/consts';

export type IHoursCheckerFilters = IExpectedHoursListFilters;

export default function useExpectedHours(
  selectedMonth?: string,
  selectedYear?: number,
  filters?: IExpectedHoursListFilters
) {
  const [expectedHours, setExpectedHours] = useState<IExpectedHoursItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const monthIndex = selectedMonth
    ? monthNames.indexOf(selectedMonth)
    : new Date().getMonth();

  const year = selectedYear ?? new Date().getFullYear();

  const fetchData = useCallback(async () => {
    if (monthIndex < 0) return;

    setExpectedHours([]);
    setIsLoading(true);
    try {
      const apiFilters = buildWorkItemsApiFilters(filters);
      const data = await getExpectedHoursForMonth(year, monthIndex + 1, apiFilters); // miesiąc 1-based
      setExpectedHours(data)

    } catch (err) {
      console.error("❌ Błąd pobierania danych:", err);
      setExpectedHours([]);
    } finally {
      setIsLoading(false);
    }
  }, [monthIndex, year, filters?.employeeId, filters?.contractType, filters?.settlementStatus]);

  const acceptSettlement = async (item: IExpectedHoursItem) => {
    await acceptSettlementRequest({
      userId: item.userId,
      year: item.year,
      month: item.month,
    });

    await fetchData();
  };

  const rejectSettlement = async (item: IExpectedHoursItem, rejectionReason: string) => {
    await rejectSettlementRequest({
      userId: item.userId,
      year: item.year,
      month: item.month,
      rejectionReason,
    });

    await fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    expectedHours,
    isLoading,
    getExpectedHours: fetchData,
    acceptSettlement,
    rejectSettlement
  };
}
